var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id, validationId) {
      


































pug_mixins["input"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.type) {
attributes.type = 'text'
}
if (!attributes.attributes) {
attributes.attributes = {}
}
if (!attributes.groupAttributes) {
attributes.groupAttributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["form-group",attributes.groupHtmlClass], [false,false])},attributes.groupAttributes]), true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes(["control-label",attributes.labelHtmlClass], [false,true]), false, true)+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
if (attributes.divTitle) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["control-label",attributes.divTitleHtmlClass], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = attributes.divTitle) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"type": pug.escape(attributes.type),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"name": pug.escape(id),"value": pug.escape(attributes.value),"required": pug.escape(attributes.required),"ng-pattern": pug.escape(attributes['ng-pattern']),"disabled": pug.escape(attributes.disabled),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};































































pug_mixins["switchbox"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["double-label-switch",attributes.containerHtmlClass], [false,false]), false, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes([attributes.labelHtmlClass], [true]), false, true)+pug.attr("for", id, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"switch round large\"\u003E\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+" type=\"checkbox\""+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("id", id, true, true)+pug.attr("name", id, true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-true-value", attributes['ng-true-value'], true, true)+pug.attr("ng-init", attributes['ng-init'], true, true)+pug.attr("ng-false-value", attributes['ng-false-value'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E\u003Clabel" + (" class=\"switch__label\""+pug.attr("for", id, true, true)) + "\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};






































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};






































































pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv class=\"cockpit-panel\" overlay=\"EmployeeFiltersCtrl.loading.main\"\u003E\u003Cdiv class=\"cockpit-panel__title\"\u003E{{EmployeeFiltersCtrl.employees.length}} {{ EmployeeFiltersCtrl.employees.length \u003E 0 ? \"Arbeitnehmer gefunden\" : \"\"}} {{EmployeeFiltersCtrl.employees.length === 0 ? \"Arbeitnehmer gefunden. Bitte mindestens einen Filter angeben\" : \"\"}}\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body employee-filters-containter\"\u003E\u003Cdiv class=\"row\"\u003E\u003Ch1 ng-if=\"EmployeeFiltersCtrl.to_show_bike_approval\"\u003EFahrrad\u003C\u002Fh1\u003E\u003Ch1 ng-if=\"EmployeeFiltersCtrl.to_show_pc_approval\"\u003EPC-Leasing\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-6 filter-input\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "filters.id","title": "ValueNetID","attributes": {"ng-model-options":"{ debounce: 300 }"},"data-cy": "vn.administration.bikeLeasing.employeeFilters.inputEmployeeId"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-6 filter-input\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "filters.custId","title": "Kunde","attributes": {"ng-model-options":"{ debounce: 300 }"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-6 filter-input\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "filters.name","title": "Vorname Name","attributes": {"ng-model-options":"{ debounce: 300 }"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-6 filter-input\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "filters.personal_number","title": "Personalnummer","attributes": {"ng-model-options":"{ debounce: 300 }"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-6 filter-input\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "filters.contract_id","title": "Contract ID","attributes": {"ng-model-options":"{ debounce: 300 }"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"column small-6 filter-input\" ng-if=\"EmployeeFiltersCtrl.to_show_bike_approval\"\u003E\u003Cdatepicker date-format=\"dd.MM.yyyy\" selector=\"entrydateInput\" date-refocus=\"false\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "filters.fahrrad_beginn","title": "Fahrrad Beginn","attributes": {"vn-date-helper":"true","ng-pattern":"\u002F^(0?[1-9]|[12][0-9]|3[01])\\.([0]?[0-9]|1[0-2])\\.\\d{4}$\u002F"},"fieldHtmlClass": "entrydateInput"}
});
pug_html = pug_html + "\u003C\u002Fdatepicker\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-6 filter-input\"\u003E\u003Cdiv\u003E\u003Clabel class=\"control-label\"\u003EApproval State\u003C\u002Flabel\u003E\u003Cui-select ng-model=\"filters.approval_state.selected\" theme=\"select2\" title=\"Approval State Filter\" search-enabled=\"false\" multiple close-on-select=\"false\" style=\"width:100%\"\u003E\u003Cui-select-match placeholder=\"Select Approval State...\"\u003E{{$item.display}}\u003C\u002Fui-select-match\u003E\u003Cui-select-choices repeat=\"approval_state.id as approval_state in filters.approval_state.options\"\u003E\u003Cspan ng-bind=\"approval_state.display\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fui-select-choices\u003E\u003C\u002Fui-select\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-6 filter-input\" ng-if=\"!!EmployeeFiltersCtrl.to_show_neo_pc_state_filter\"\u003E\u003Cdiv\u003E\u003Clabel class=\"control-label\"\u003EBO PC-Leasing state\u003C\u002Flabel\u003E\u003Cui-select ng-model=\"filters.neo_pc_state.selected\" theme=\"select2\" title=\"'PC-Leasing state filter\" search-enabled=\"false\" multiple close-on-select=\"false\" style=\"width:100%\"\u003E\u003Cui-select-match placeholder=\"Select PC-Leasing State...\"\u003E{{$item.display}}\u003C\u002Fui-select-match\u003E\u003Cui-select-choices repeat=\"pc_state.id as pc_state in filters.neo_pc_state.options\"\u003E\u003Cspan ng-bind=\"pc_state.display\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fui-select-choices\u003E\u003C\u002Fui-select\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns small-6 filter-input\" ng-if=\"!!EmployeeFiltersCtrl.to_show_order_process_filter\"\u003E\u003Cdiv\u003E\u003Clabel class=\"control-label\"\u003EAuftragsstatus\u003C\u002Flabel\u003E\u003Cui-select ng-model=\"filters.order_process_states.selected\" theme=\"select2\" title=\"'Order Process states filter\" search-enabled=\"false\" multiple close-on-select=\"false\" style=\"width:100%\"\u003E\u003Cui-select-match placeholder=\"Select Order Process State...\"\u003E{{$item.display}}\u003C\u002Fui-select-match\u003E\u003Cui-select-choices repeat=\"orderState.id as orderState in filters.order_process_states.options\"\u003E\u003Cspan ng-bind=\"orderState.display\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fui-select-choices\u003E\u003C\u002Fui-select\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-12\"\u003E\u003Cbutton class=\"button button-primary right\" ng-click=\"EmployeeFiltersCtrl.search();\" data-cy=\"vn.administration.bikeLeasing.employeeFilters.buttonSearch\"\u003ESuchen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit_arbeitnmv-wrapper\"\u003E\u003Cdiv class=\"list-box\" overlay=\"EmployeeFiltersCtrl.loading.main\"\u003E\u003Cdiv ng-repeat=\"(employee_group_id, employee_group) in EmployeeFiltersCtrl.grouped_employees\"\u003E\u003Cdiv class=\"list-box__row\"\u003E\u003Cdiv class=\"list-box__item\"\u003E\u003Cspan class=\"list-box__itemTitle\"\u003E\u003Cspan class=\"user-name\" style=\"font-weight: bold\"\u003E{{EmployeeFiltersCtrl.customers_by_id[employee_group_id].name }} {{EmployeeFiltersCtrl.customers_by_id[employee_group_id].name ? ' - ' : ' '}} {{ employee_group_id}}\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"list-box__row\" ng-class=\"{'toggable-content-open': EmployeeFiltersCtrl.employee_objects[employeeData.id].toggleContentShowable }\" ng-repeat=\"employeeData in employee_group\" toggable-content=\"EmployeeFiltersCtrl.employee_objects[employeeData.id].toggleContentShowable\"\u003E\u003Ctoggable-content-toggler ng-init=\"employee = EmployeeFiltersCtrl.employee_objects[employeeData.id]\" ng-click=\"EmployeeFiltersCtrl.loadEmployeeData(employeeData, employee, toggleContentShowable)\"\u003E\u003Cdiv class=\"list-box__item\"\u003E\u003Cspan class=\"list-box__itemTitle\" ng-click=\"toggableContentCtrl.togglerClicked()\" data-cy=\"vn.administration.bikeLeasing.{{employeeData.id}}.toggleEmployeeData\"\u003E\u003Cdiv class=\"toggable-state-feedback\"\u003E\u003C\u002Fdiv\u003E\u003Cspan class=\"user-name\"\u003E{{ employeeData.id | formatNumber:'prepend'}} | {{ employeeData.lastname }}, {{ employeeData.firstname }}\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003Cdiv class=\"row second-row\"\u003E\u003Cdiv class=\"columns text-right an-verwaltung-padding\"\u003E\u003Cbutton class=\"button button-primary isOutline\" ng-click=\"EmployeeFiltersCtrl.become( employeeData )\"\u003ENutzer übernehmen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftoggable-content-toggler\u003E\u003Cdiv class=\"list-box__item__content\" toggable-content-content ng-class=\"{'ng-enter': EmployeeFiltersCtrl.employee_objects[employeeData.id].toggleContentShowable, 'ng-enter-active': EmployeeFiltersCtrl.employee_objects[employeeData.id].toggleContentShowable}\" ng-if=\"EmployeeFiltersCtrl.employee_objects[employeeData.id].toggleContentShowable &amp;&amp; (EmployeeFiltersCtrl.to_show_bike_approval || EmployeeFiltersCtrl.to_show_pc_approval  ) \"\u003E\u003Cdiv class=\"cockpit_toggable-content\" ng-if=\"employeeData.pc_approvals\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-1\"\u003E\u003Ch4\u003EBeginn\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-1\"\u003E\u003Ch4\u003EEnde\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Ch4\u003EBrutto\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Ch4\u003EMonatliche Rate\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Ch4\u003EApproval Status\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Ch4\u003EOrder Status\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\" ng-if=\"EmployeeFiltersCtrl.to_show_neo_pc_state_filter\"\u003E\u003Ch4\u003EApprove Basket\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-repeat=\"approval in employeeData.pc_approvals track by $index\" style=\"font-size:12px\"\u003E\u003Cdiv class=\"columns medium-1 contract-data\"\u003E{{ approval.entity.beginDate ? ( approval.entity.beginDate  | date ) : '-' }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-1 contract-data\"\u003E{{ approval.entity.endDate ? ( approval.entity.endDate | date ) : '-' }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2 contract-data\"\u003E{{ approval.entity.sum | currency }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2 contract-data\"\u003E{{ approval.entity.leasing | currency }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2 contract-data\"\u003E{{ EmployeeFiltersCtrl.APPROVAL_PROCESS_STATES_BY_ID[approval.state_id]['display'] ? EmployeeFiltersCtrl.APPROVAL_PROCESS_STATES_BY_ID[approval.state_id]['display'] : '-'}}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2 contract-data\"\u003E{{ approval.entity.order_process ? EmployeeFiltersCtrl.ORDER_STATUSES_BY_ID[approval.entity.order_process.state_id]['display'] : '-'}}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2 contract-data\" ng-if=\"EmployeeFiltersCtrl.to_show_neo_pc_state_filter\" ng-init=\"EmployeeFiltersCtrl.approveBasket[approval.mpp_basket._id] = !!approval.mpp_basket.isApproved\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"id": "switchBasket-{{employeeData.id}}-{{$index}}","key": "EmployeeFiltersCtrl.approveBasket[approval.mpp_basket._id]","ng-change": "EmployeeFiltersCtrl.triggerBasketApprove(approval.entity._id)"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Cbutton class=\"button button-primary button-small-header isOutline right\" ng-if=\"EmployeeFiltersCtrl.canCommunicate(approval)\" ng-click=\"EmployeeFiltersCtrl.resendCommunicationMails(approval)\" ng-disabled=\"EmployeeFiltersCtrl.loading.resend_communication\"\u003EE-Mails senden\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C!--  button.button.button-primary.button-small-header.isOutline.right(--\u003E\u003C!--    ng-if=\"approval.validations.flows[APPROVAL_PROCESS_FLOWS_BY_NAME['internal_decline']['name']].can_enter\"--\u003E\u003C!--    ng-click=\"EmployeeFiltersCtrl.openPCDeclineDialog(approval, employeeData.id)\"--\u003E\u003C!--  ) Ablehnen--\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"EmployeeFiltersCtrl.to_show_bike_approval &amp;&amp; !employeeData.bikeleasing_approvals.length &gt; 0\"\u003E\u003Cspan class=\"error\"\u003EEs ist keine Freigabe offen\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit_toggable-content\" ng-if=\"employeeData.bikeleasing_approvals\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Ch4\u003EContract ID\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3\"\u003E\u003Ch4\u003EUmwandlungsrate\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3\"\u003E\u003Ch4\u003EFreigabe AG\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-repeat=\"approval in employeeData.bikeleasing_approvals | orderBy: 'dates.bonus_start_date' \"\u003E\u003Cdiv class=\"columns medium-2 contract-data small\"\u003E\u003Ca href=\"https:\u002F\u002Fbikeleasing-service.crm4.dynamics.com\u002Fmain.aspx?appid=0eef356e-01e0-417e-838b-27338bb68b96&amp;pagetype=entityrecord&amp;etn=asc_leasingvertrag&amp;id={{ approval.neo_bikeleasing.contract_id }}\" target=\"_blank\"\u003E{{ approval.neo_bikeleasing.contract_id }}\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3 contract-data\"\u003E{{ approval.entity.per_month_value | number:2 }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3 contract-data\" data-cy=\"vn.administration.bikeLeasing.{{employeeData.id}}-{{approval.neo_bikeleasing._id}}.textApprovalState\"\u003E{{ EmployeeFiltersCtrl.APPROVAL_PROCESS_STATES_BY_ID[approval.state_id]['display'] }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-1\"\u003E\u003Cbutton class=\"button button-primary button-small-header isOutline right\" ng-if=\"EmployeeFiltersCtrl.canApproveNeoBikeleasing(approval)\" ng-click=\"EmployeeFiltersCtrl.openBikeleasingApproveDialog(approval)\" data-cy=\"vn.administration.bikeLeasing.{{employeeData.id}}-{{approval.neo_bikeleasing._id}}.buttonFinalApproval\"\u003EFreigabe\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary button-small-header isOutline right\" ng-click=\"EmployeeFiltersCtrl.openBikeleasingEditDialog(approval)\" data-cy=\"vn.administration.bikeLeasing.{{employeeData.id}}-{{approal.neo_bikeleasing._id}}.buttonEdit\"\u003EEdit\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "validationId" in locals_for_with ?
        locals_for_with.validationId :
        typeof validationId !== 'undefined' ? validationId : undefined));
    ;;return pug_html;};
module.exports = template;